import axios from "axios";     

//base url to make requests to the movie database

const instance = axios.create({
    baseURL: "https://api.themoviedb.org/3",
});

/*example: if we run the following code
instance.get('foo-bar');
then, 
the above link will become 
https://api.themoviedb.org/3/foo-bar
so, we are just sending requests here
*/

export default instance; // you can only have 1 default export in a file

